<script setup lang="ts">
const runtimeConfig = useRuntimeConfig();
const gtagId = runtimeConfig.public.gtagId;

useHead(() => {
  if (!gtagId) {
    return {};
  }

  return {
    script: [
      {
        src: `https://www.googletagmanager.com/gtag/js?id=${gtagId}`,
        async: true,
      },
      {
        type: "text/javascript",
        innerHTML: `window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag("js", new Date()); gtag("config", "${gtagId}");`,
      },
    ],
  };
});
</script>

<template>
  <NuxtLayout>
    <AppGlobalBreadcrumbs />
    <NuxtPage />
  </NuxtLayout>
</template>
